import debug from 'debug';

type LogMethod = (...args: unknown[]) => void;

interface Logger extends LogMethod {
  debug: LogMethod;
  info: LogMethod;
  warn: LogMethod;
  error: LogMethod;
}

export const logger = (ns: string): Logger => {
  const base = debug(ns);
  const info = debug(`${ns}:info`);
  const warn = debug(`${ns}:warn`);
  const error = debug(`${ns}:error`);

  const log = ((...args: unknown[]) => base(...(args as [unknown, ...unknown[]]))) as Logger;

  log.debug = (...args: unknown[]) => {
    base(...(args as [unknown, ...unknown[]]));
  };

  log.info = (...args: unknown[]) => {
    info(...(args as [unknown, ...unknown[]]));
  };

  log.warn = (...args: unknown[]) => {
    warn(...(args as [unknown, ...unknown[]]));
    console.warn(`[WARN] ${ns}`, ...args);
  };

  log.error = (...args: unknown[]) => {
    if (error.enabled) error(...(args as [unknown, ...unknown[]]));
    console.error(`[ERROR] ${ns}`, ...args);
  };

  return log;
};

export const voLogger = (suffix: string): Logger => logger(`vo:${suffix}`);
export const appLogger = (suffix: string): Logger => logger(`app:${suffix}`);
